// @flow

import { getUserAgent } from './isomorphic-useragent';
import MobileDetect from 'mobile-detect';
import { isGooglebotMobile } from './googlebot';

// Mobile device detection
export const isMobileUserAgent = (): boolean => {
  const ua = getUserAgent();
  if (isGooglebotMobile(ua)) {
    return true;
  }
  const md = new MobileDetect(ua);
  return Boolean(md.mobile());
};

export const currentDevice = (): MobileDevices => {
  const md = new MobileDetect(getUserAgent());
  const device = md.phone() === 'iPhone' ? md.phone() : md.os(); // MobileDetect is far from perfect
  switch (device) {
    case 'iPhone':
      return 'iPhone';
    case 'AndroidOS':
      return 'Android';
    default:
      return 'Other';
  }
};
